import {createContext} from 'react'
import ReactDOM from 'react-dom/client'
import App from './app/App'
import Store from './stores/index'
import { BrowserRouter } from 'react-router-dom'
import LoyaltyStoreX from './stores/loyalty'
import GoodsStore from './stores/goods'
import AdminStore from './stores/admin'
import { PayStore } from './stores/pay'
import { BranchesApiStore, OrdersApiStore, ProductStore, ShopApiStore, StatusStore, SubscribeStore, UserApiStore } from './stores/api'

import '@ant-design/v5-patch-for-react-19'

import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import * as Sentry from "@sentry/react"

dayjs.locale('ru')

// Раньше подскажем браузеру скачать картинку заглушки — до React и до запроса настроек.
{
  const path = window.location.pathname
  if (path === "/store" || path.startsWith("/store/")) {
    const base = process.env.PUBLIC_URL || ""
    const href = `${base}/assets/images/statuses/story_new.webp`
    const link = document.createElement("link")
    link.rel = "preload"
    link.as = "image"
    link.href = href
    link.setAttribute("fetchpriority", "high")
    document.head.appendChild(link)
  }

  console.log(`You are running this application in %c${process.env.NODE_ENV}%c mode.`, `font-weight: 900;font-size: 18px;`, `font-weight: 500;`)

  // Грузим Sentry только на проде
  if (process.env.REACT_APP_SENTRY_DSN !== undefined && process.env.NODE_ENV === "production") {
    window.sentry = Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      sendDefaultPii: true
    })
  }
}

// Перезагружаем страницу при ChunkLoadError — это происходит когда был задеплоен
// новый билд, а браузер пытается загрузить старый JS/CSS-чанк которого уже нет.
window.addEventListener('error', (event) => {
  if (
    event.message?.includes('Loading chunk') ||
    event.message?.includes('Loading CSS chunk')
  ) {
    window.location.reload()
  }
})

interface State {
  store: Store
  adminStore: AdminStore
  loyaltyStore: LoyaltyStoreX
  goodsStore: GoodsStore

  shopStore: ShopApiStore
  userStore: UserApiStore
  orderStore: OrdersApiStore
  branchesStore: BranchesApiStore
  productStore: ProductStore
  subStore: SubscribeStore
  statusStore: StatusStore
  payStore: PayStore
}

const store = new Store()
const payStore = new PayStore()
const adminStore = new AdminStore()
const loyaltyStore = new LoyaltyStoreX()
const goodsStore = new GoodsStore()

const statusStore = new StatusStore(store, loyaltyStore)
const subStore = new SubscribeStore(store, loyaltyStore)
const productStore = new ProductStore(store, loyaltyStore)
const shopStore = new ShopApiStore(store, loyaltyStore)
const userStore = new UserApiStore(store, loyaltyStore)
const orderStore = new OrdersApiStore(store, loyaltyStore)
const branchesStore = new BranchesApiStore(store, loyaltyStore)

const allStores: State = { 
  store, loyaltyStore, statusStore, adminStore, goodsStore, subStore,
  orderStore, shopStore, userStore, branchesStore, productStore, payStore
}

export const Context = createContext<State>(allStores)

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

root.render(
  <Context.Provider value={allStores}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Context.Provider>
)

// reportWebVitals()
